module.exports = ['$scope', 'ngMeta', 'bibContentManager', '$stateParams', '$state', '$location', 'settings', '$window', '$document', '$timeout',
  function ($scope, ngMeta, bibContentManager, $stateParams, $state, $location, settings, $window, $document, $timeout) {
    'use strict';

    var offset = 105;
    var viewItem;
    $scope.footnotes = [];

    var scollListner = function (e) {
      if (viewItem) {
        viewItem.contents.filter(o => o.type === 'SECTION').forEach(function (content) {
          content.prevPosition = elmYPosition(content.key) - 1;
          content.nextPosition = elmYEndPosition(content.key);
        });

        const position = $window.scrollY;
        let key;

        if (viewItem && viewItem.contents) {
          const current = viewItem.contents.filter(function (o) {
            return o.prevPosition < position + offset && o.nextPosition > position + offset && o.type === 'SECTION';
          })[0];
          if (current) {
            key = current.key;
          } else {
            key = viewItem.key;
          }
          if (key) {
            $scope.selected = key;
            $scope.item = $scope.$parent.find(key);
            $scope.$apply();
          }
        }
      }
    };

    $document.on('scroll', scollListner);

    $scope.$on('$destroy', function () {
      $document.off('scroll', scollListner);
    });

    $scope.$parent.loadedPromise.then(function (document) {
      var item = $scope.$parent.find($stateParams.key);
      var root;
      var firstItem;
      if (!item) {
        $state.go('notFound', {}, { location: false });
      } else if (item.parent) {
        if (item.parent.parent) {
          if (item.parent.parent.parent) {
            root = $scope.$parent.find(item.parent.parent.key);
            viewItem = $scope.$parent.find(item.parent.key);
            item.level = 3;
            $timeout(function () {
              window.scrollTo(0, elmYPosition(item.key) - offset  + 1);
            });
          } else {
            viewItem = item;
            root = $scope.$parent.find(item.parent.key);
            item.level = 2;
          }
        } else {
          firstItem = _.find(item.contents, {readorder: 1});
          if (firstItem) {
            $state.go('concept.krachtlijnen.view', {key: firstItem.key}, {location: false});
          } else {
            root = item;
          }
        }

        if (item && item.cover) {
          $scope.$parent.$parent.coverImg = item.cover.url;
        } else if (root && root.cover) {
          $scope.$parent.$parent.coverImg = root.cover.url;
        }

        if (viewItem) {
          ngMeta.setTitle(viewItem.title);
        } else {
          ngMeta.setTitle(item.title);
        }

        $scope.document = document;
        $scope.item = item;
        $scope.root = root;
        $scope.viewItem = viewItem;
        $scope.selected = $scope.item.key;
        if(root) {
          $scope.$parent.$parent.extraBreadcrumb = root.title;
        }

        if (viewItem && viewItem.cover) {
          $scope.$parent.$parent.coverImg = viewItem.cover.url;
        } else {
          $scope.$parent.$parent.coverImg = document.cover.url;
        }

        if(root && viewItem) {
          $scope.next = root.contents[root.contents.indexOf(viewItem) + 1];
          $scope.prev = root.contents[root.contents.indexOf(viewItem) - 1];
          $scope.$parent.findNext($scope.viewItem);
        }

      }
    });


    /*function replaceRef (html) {
      html.match(/<a.*href=".*(\/content\/[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}).*".*>\[(.*)\]<\/a>/g).forEach(function (matchItem) {
        var footnote = (/([0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12})/).exec(matchItem);
        $scope.footnotes.push($scope.$parent.find(footnote[1]));
      });
      $scope.footnotes = _.uniq($scope.footnotes);
      return html.replace(/<a.*href=".*(\/content\/[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}).*".*>\[(.*)\]<\/a>/g, "<sup>$2</sup>")
    };*/

    function elmYPosition (eID) {
      var elm = document.getElementById(eID);
      if (! elm) {
        console.warn(eID + ' is not found');
      } else {
        var y = elm.offsetTop;
        var node = elm;
        while (node.offsetParent && node.offsetParent != document.body) {
          node = node.offsetParent;
          y += node.offsetTop;
        }
        return y;
      }
    }

    function elmYEndPosition (eID) {
      var elm = document.getElementById(eID);
      if (! elm) {
        console.warn(eID + ' is not found');
      } else {
        var y = elm.offsetTop + elm.offsetHeight;
        var node = elm;
        while (node.offsetParent && node.offsetParent != document.body) {
          node = node.offsetParent;
          y += node.offsetTop;
        }
        return y;
      }
    }


    $scope.find = $scope.$parent.find;

    $scope.goLevel3 = function (key) {
      window.scrollTo(0, elmYPosition(key) - offset + 1);
    };

    $scope.hasSections = function (item) {
      return item.contents.filter(t => t.type === 'SECTION').length > 0;
    };
  }
];



// WEBPACK FOOTER //
// ./web/js/screen/concept/krachtlijnen/view/conceptKrachtlijnenViewController.js